// 合作類型對應
export const CONTRACT_MODE = {
  BUYOUT_MONTHLY_DOMESTIC: 1, // 買斷月結 - 國內
  BUYOUT_MONTHLY_FOREIGN: 2, // 買斷月結 - 國外
  CONSIGNMENT: 3, // 寄倉
  TRANS_SHIPMENT: 4, // 轉單
  BUYOUT_PREPAID_DOMESTIC: 5, // 買斷預付100% - 國內
  BUYOUT_PREPAID_FOREIGN: 6, // 買斷預付100% - 國外
} as const;

// 合作類型顯示文字
export const CONTRACT_MODE_TEXT: { [key: number]: string } = {
  1: "買斷月結",
  2: "買斷月結",
  3: "寄倉",
  4: "轉單",
  5: "買斷預付100%",
  6: "買斷預付100%",
};

// 合作類型 Filter 選項 ！！BE要求合併國內外為一個選項
export const contractModeFilterOptions = [
  {
    label: CONTRACT_MODE_TEXT[CONTRACT_MODE.BUYOUT_MONTHLY_DOMESTIC],
    value: `${CONTRACT_MODE.BUYOUT_MONTHLY_DOMESTIC},${CONTRACT_MODE.BUYOUT_MONTHLY_FOREIGN}`,
  },
  { label: CONTRACT_MODE_TEXT[CONTRACT_MODE.CONSIGNMENT], value: CONTRACT_MODE.CONSIGNMENT.toString() },
  { label: CONTRACT_MODE_TEXT[CONTRACT_MODE.TRANS_SHIPMENT], value: CONTRACT_MODE.TRANS_SHIPMENT.toString() },
  {
    label: CONTRACT_MODE_TEXT[CONTRACT_MODE.BUYOUT_PREPAID_DOMESTIC],
    value: `${CONTRACT_MODE.BUYOUT_PREPAID_DOMESTIC},${CONTRACT_MODE.BUYOUT_PREPAID_FOREIGN}`,
  },
];
export const contractModeOptions = [
  { label: CONTRACT_MODE_TEXT[CONTRACT_MODE.BUYOUT_MONTHLY_DOMESTIC], value: CONTRACT_MODE.BUYOUT_MONTHLY_DOMESTIC },
  { label: CONTRACT_MODE_TEXT[CONTRACT_MODE.CONSIGNMENT], value: CONTRACT_MODE.CONSIGNMENT },
  { label: CONTRACT_MODE_TEXT[CONTRACT_MODE.TRANS_SHIPMENT], value: CONTRACT_MODE.TRANS_SHIPMENT },
  { label: CONTRACT_MODE_TEXT[CONTRACT_MODE.BUYOUT_PREPAID_DOMESTIC], value: CONTRACT_MODE.BUYOUT_PREPAID_DOMESTIC },
];

// 狀態對應
export const CONTRACT_STATUS = {
  INACTIVE: 0, // 未生效
  ACTIVE: 1, // 生效中
  ENDED: 2, // 已結束
  DISABLED: 3, // 已停用
} as const;

export const CONTRACT_STATUS_TEXT: { [key: number]: string } = {
  0: "未生效",
  1: "生效中",
  2: "已結束",
  3: "已停用",
};

export const contractStatusOptions = [
  { label: CONTRACT_STATUS_TEXT[CONTRACT_STATUS.INACTIVE], value: CONTRACT_STATUS.INACTIVE.toString() },
  { label: CONTRACT_STATUS_TEXT[CONTRACT_STATUS.ACTIVE], value: CONTRACT_STATUS.ACTIVE.toString() },
  { label: CONTRACT_STATUS_TEXT[CONTRACT_STATUS.ENDED], value: CONTRACT_STATUS.ENDED.toString() },
  { label: CONTRACT_STATUS_TEXT[CONTRACT_STATUS.DISABLED], value: CONTRACT_STATUS.DISABLED.toString() },
];

export const getStatusColor = (status: number) => {
  switch (status) {
    case CONTRACT_STATUS.INACTIVE:
      return "orange";
    case CONTRACT_STATUS.ACTIVE:
      return "success";
    case CONTRACT_STATUS.ENDED:
      return "default";
    case CONTRACT_STATUS.DISABLED:
      return "error";
    default:
      return "default";
  }
};

// 買斷月結/買斷預付100% 必填欄位
export const ContractFieldType1 = [
  { name: "depositAmount", required: false, label: "保證金", help: "合作保證用以擔保履約" },
  { name: "minOrderQty", required: true, label: "最低訂購量", help: "每次下單最小採購數量" },
  { name: "arrivalDays", required: true, label: "到貨天數", help: "下單後幾天內須送達倉庫" },
  { name: "acceptableDays", required: true, label: "允收天數", help: "商品剩餘可賣天數要求" },
  { name: "returnableDays", required: true, label: "允退天數", help: "商品剩餘可退天數要求" },
];

// 寄倉/轉單 必填欄位
export const ContractFieldType2 = [
  { name: "depositAmount", required: true, label: "保證金", help: "合作保證用以擔保履約" },
  { name: "minOrderQty", required: false, label: "最低訂購量", help: "每次下單最小採購數量" },
  { name: "arrivalDays", required: true, label: "到貨天數", help: "下單後幾天內須送達倉庫" },
  { name: "acceptableDays", required: true, label: "允收天數", help: "商品剩餘可賣天數要求" },
  { name: "returnableDays", required: true, label: "允退天數", help: "商品剩餘可退天數要求" },
];

export const getBackChargeText = (contractMode: number | undefined) => {
  if (!contractMode) return "-";
  const modeNum = Number(contractMode);
  switch (modeNum) {
    case CONTRACT_MODE.CONSIGNMENT:
      return "1 – 9 月固定為 8.5%，10 月 9.5%、11 月 10.5%、12 月 9.5%";
    case CONTRACT_MODE.TRANS_SHIPMENT:
      return "1 – 9 月固定為 10%，10 月 11%、11 月 12%、12 月 11%";
    default:
      return "-";
  }
};
